<template lang="pug">
  .toggle-blocks
    .block
      .title-area(
        :class="{'open-block': forms.questions.open}"
        @click="toggleAccordionAndCloseOthers('questions')"
      )
        h5 {{ __('Questions About Your Order?') }}
        Icon.icon-size-xxs(
          :name="forms.questions.open ? 'minus' : 'plus'"
          fill="gray"
        )
      .open-form(v-show="forms.questions.open")
        ZendeskForm(
          :id="$rogue.keys.rssform"
          :prePopulate="orderItems"
        )
    .block
      .title-area(
        :class="{'open-block': forms.trackAnother.open}"
        @click="toggleAccordionAndCloseOthers('trackAnother')"
      )
        h5 {{ __('Track Another Order') }}
        Icon.icon-size-xxs(
          :name="forms.trackAnother.open ? 'minus' : 'plus'"
          fill="gray"
        )
      .open-form(v-if="forms.trackAnother.open")
        p.form-description
          | {{ __('To track an order, enter a order number and the email used when your order was placed.') }}
        track-order-form
    .block(v-if="order.currentPackageStatus === 'delivered' && !order.isPickup")
      .title-area(@click="redirectToReturnPage")
        h5 {{ __('Start a Return') }}
        Icon.icon-size-xxs(
          name="arrow-right"
          fill="gray"
        )
</template>

<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router'
import { computed, reactive } from 'vue'
import type { TrackedOrder } from '../rssTypes'
import trackOrderForm from './track-order-form.vue'

const props = withDefaults(defineProps<{
  order?: Pick<TrackedOrder, 'orderNumber' | 'email' | 'isPickup' | 'currentPackageStatus'>
}>(), {
  order: () => ({
    orderNumber          : '',
    email                : '',
    isPickup             : false,
    currentPackageStatus : '',
  }),
})

const router = useRouter()
const route = useRoute()

const forms = reactive<{ [key: string]: { open: boolean } }>({
  trackAnother: {
    open: false,
  },
  questions: {
    open: false,
  },
})

function toggleAccordionAndCloseOthers(key: string): void {
  const formKeys = Object.keys(forms)
  for (let i = 0; i < formKeys.length; i += 1) {
    if (forms[formKeys[i]].open && formKeys[i] === key) {
      forms[formKeys[i]].open = false
    } else if (formKeys[i] === key) {
      forms[formKeys[i]].open = true
    } else {
      forms[formKeys[i]].open = false
    }
  }
}

function redirectToReturnPage(): void {
  router.push({ path: '/rmaprocess', query: route.query })
}

const orderItems = computed(() => ({
  Email          : { value: props.order.email, hide: false },
  'Order Number' : { value: props.order.orderNumber, hide: true },
}))
</script>

<style lang="scss" scoped>
  .toggle-blocks {
    display        : flex;
    flex-direction : column;
    padding        : $space-s;
    background     : $color-white;
    height         : 100%;
  }

  .block {
    border        : $border-width-thin solid $color-gray-light;
    margin-bottom : $space-xxs;

    &:last-of-type {
      margin-bottom : 0;
    }

    .open-block {
      padding-bottom : $space-xs;
    }

    .open-form {
      padding : 0 $space-xs $space-xs;
    }

    .icon-plus, .icon-minus, .icon-arrow-right {
      margin         : 0 $space-xxs;
      pointer-events : none;
      color          : $color-gray-dark;
    }

    .title-area {
      display         : flex;
      justify-content : space-between;
      align-items     : center;
      user-select     : none;
      cursor          : pointer;
      padding         : $space-xs;

      h5 {
        font-family    : $font-condensed;
        margin         : 0;
        text-transform : uppercase;
      }
    }

    .success-message {
      .msg-text {
        margin-bottom : 0;
      }
    }

    .error-msg {
      margin-bottom: $space-xs;
      .msg-text {
        margin-bottom : 0;
      }
    }

    .form-description {
      font-size     : $size-xs;
      margin-bottom : $space-xs;

      .order-number {
        font-weight : bold;
      }
    }
  }
</style>
